import React, { useEffect, useState } from "react";
import Style from "../style/cityfilter.module.scss";
import { getProductsFromDB, saveProductsToDB } from "../indexDb/productDb";
import { getStatesFromDB } from "../indexDb/stateDb";
import { fetchListing } from "../redux/Slice";
import { useAppDispatch } from "../redux/hooks";
import { useParams } from "react-router-dom";
import Loader from "../Loader/Loader";
import ProductListingData from "../ProductListing/ProductListingData";
import ProductRightContent from "../ProductListing/ProductRightContent";
import SeachResultOverlay from "../component/SeachResultOverlay";
import ProductBanner from "../ProductListing/ProductBanner";
import ProductDivide from "../ProductListing/ProductDivide";

const images = [
  "https://wallpapers.com/images/hd/the-american-state-of-florida-ms5bnvwedsbx3j6c.jpg",
  "https://images.pexels.com/photos/37646/new-york-skyline-new-york-city-city-37646.jpeg?cs=srgb&dl=pexels-pixabay-37646.jpg&fm=jpg",
  "https://images.unsplash.com/photo-1518235506717-e1ed3306a89b?fm=jpg&q=60&w=3000&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTB8fG5ldyUyMHlvcmslMjB3YWxscGFwZXJ8ZW58MHx8MHx8fDA%3D",
  "https://t4.ftcdn.net/jpg/01/14/62/09/360_F_114620950_cVKI6ECnKJLdO2RD4uGM0OLebRD5opOG.jpg",
];

const CityFilter = () => {
  const { userState, userCity } = useParams();
  const dispatch = useAppDispatch();
  const [localListings, setLocalListings] = useState<any[]>([]);
  const [cityList, setCityList] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [overlay, setOverlay] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 9;

  const [backgroundImage, setBackgroundImage] = useState("");

  useEffect(() => {
    const randomImage = images[Math.floor(Math.random() * images.length)];
    setBackgroundImage(randomImage);
  }, []);

  useEffect(() => {
    const loadData = async () => {
      setLoading(true);
      const cityData = await getStatesFromDB();
      setCityList(cityData);
      const localProducts: any = await getProductsFromDB();
      if (localProducts.length > 0) {
        setLocalListings(localProducts);
        dispatch(fetchListing(localProducts));
      }
      if (localProducts.length === 0) {
        try {
          const apiData = await dispatch(fetchListing()).unwrap();
          if (apiData?.listings?.length > 0) {
            setLocalListings(apiData.listings);
            await saveProductsToDB(apiData.listings);
          }
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      }

      setLoading(false);
    };

    loadData();
  }, [dispatch]);

  const currentState = cityList.find((state: any) => state.slug === userState);
  const currentStateId = currentState?.id;
  const currentCity = cityList.find((state: any) => state.slug === userState);
  const currentCityId = currentCity?.id;

  const filterItem = localListings.filter(
    (item) =>
      item.state_id === currentStateId &&
      currentCityId === userState &&
      userCity
  );

  const filterStateContent = cityList.filter((item) => item.slug === userState);

  const handleOverlay = () => {
    setOverlay(true);
  };

  const totalPages = Math.ceil(filterItem.length / itemsPerPage);

  const paginatedItems = filterItem.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const goToPage = (page: number) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const renderPagination = () => {
    const pages: (string | number)[] = [];

    if (totalPages <= 5) {
      for (let i = 1; i <= totalPages; i++) pages.push(i);
    } else {
      if (currentPage <= 2) {
        pages.push(1, 2, 3, "...", totalPages);
      } else if (currentPage >= totalPages - 1) {
        pages.push(1, "...", totalPages - 2, totalPages - 1, totalPages);
      } else {
        pages.push(
          1,
          "...",
          currentPage - 1,
          currentPage,
          currentPage + 1,
          "...",
          totalPages
        );
      }
    }
    return (
      <div className={Style.pagination}>
        <button
          onClick={() => goToPage(currentPage - 1)}
          disabled={currentPage === 1}
        >
          Previous
        </button>
        {pages.map((p, i) =>
          p === "..." ? (
            <span key={i}>...</span>
          ) : (
            <button
              key={i}
              className={p === currentPage ? Style.activePage : ""}
              onClick={() => goToPage(Number(p))}
            >
              {p}
            </button>
          )
        )}
        <button
          onClick={() => goToPage(currentPage + 1)}
          disabled={currentPage === totalPages}
        >
          Next
        </button>
      </div>
    );
  };

  return (
    <div className={Style.container}>
      {loading && (
        <div className={Style.loader}>
          <div className="spinner">
            <Loader />
          </div>
        </div>
      )}
      {overlay && <SeachResultOverlay handleClick={() => setOverlay(false)} />}
      <div className={Style.Content}>
        <div
          className={Style.banner}
          style={{ backgroundImage: `url(${backgroundImage})` }}
        >
          <div className={Style.wrapper}>
            <div className={Style.breadcrumb}>
              <a href="/">Home</a>
              <i className="fa-solid fa-angle-right"></i>
              <a href="/usa">Usa</a>
              {userState && (
                <>
                  <i className="fa-solid fa-angle-right"></i>
                  <span>
                    {userState
                      .replaceAll("-", " ")
                      .replace(/\b\w/g, (char) => char.toUpperCase())}
                  </span>
                </>
              )}
            </div>
            <div className={Style.title}>
              <h2>
                {userState
                  ?.replaceAll("-", " ")
                  .replace(/\b\w/g, (char) => char.toUpperCase())}
              </h2>
            </div>
          </div>
        </div>
        <div className={Style.mainbox}>
          <div className={Style.leftAside}>
            <ProductDivide />
            <ProductBanner />
            {paginatedItems.map((item, index) => {
              return <ProductListingData itemList={item} index={index} />;
            })}
            {renderPagination()}
          </div>
          <div className={Style.rightAside}>
            <ProductRightContent handleOverlay={handleOverlay} />
          </div>
        </div>
        {filterStateContent.map((item) => {
          return (
            <div
              className={Style.description}
              dangerouslySetInnerHTML={{ __html: item.description }}
            />
          );
        })}
      </div>
    </div>
  );
};

export default CityFilter;
